import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-white py-10 md:py-20 px-6" data-id="element-165">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-166">
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed mb-6 italic" data-id="element-167">
          Entrás a tu casa después de un día de trabajo agotador. Abrís la
          puerta y ahí está: ese olor. Ese golpe ácido y punzante que ya conocés
          de memoria. Mirás el sofá que todavía estás pagando en cuotas y ves la
          mancha de humedad. Sentís impotencia, una bronca sorda y, lo peor de
          todo, una culpa enorme por estar enojado con el ser que más amás en tu
          vida.
        </p>
      </motion.div>
    </section>;
}